module.exports = __webpack_public_path__ + "img/tiny-plus-bold.33cc861f.svg";